// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"1b991356","578":"7cbdbbd7","977":"9e3561f6"}[chunkId] + ".chunk.js";
};